import { c as _c } from "react/compiler-runtime";
import { IconButton } from '@repo/design-system/components/ds/button';
import { Icon } from '@repo/design-system/components/ds/icon';
import { FlexColumn } from '@repo/design-system/components/layout/flex-column';
import { useT } from '@repo/i18n/components/i18n.client';
import { css } from '@repo/panda/css';
import { useMapControls } from '../game-map/hooks/useMapControls';
export const ZoomControls = () => {
  const $ = _c(20);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["game_map"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useT(t0);
  const {
    zoomIn,
    zoomOut
  } = useMapControls();
  const zoomInButtonStyles = _temp;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = css.raw({
      background: "white",
      borderRadius: "full",
      boxShadow: "lg"
    });
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t(_temp2);
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = css(zoomInButtonStyles("in"));
    t4 = <Icon icon="add" decorative={true} />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== zoomIn) {
    t5 = <IconButton onClick={zoomIn} color="white" size="lg" aria-label={t2} className={t3}>{t4}</IconButton>;
    $[6] = t2;
    $[7] = zoomIn;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <hr className={css({
      width: "full",
      height: "[1px]",
      borderColor: "blackAlpha.10"
    })} />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t) {
    t7 = t(_temp3);
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = css(zoomInButtonStyles("out"));
    t9 = <Icon icon="remove" decorative={true} />;
    $[12] = t8;
    $[13] = t9;
  } else {
    t8 = $[12];
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t7 || $[15] !== zoomOut) {
    t10 = <IconButton onClick={zoomOut} color="white" size="lg" aria-label={t7} className={t8}>{t9}</IconButton>;
    $[14] = t7;
    $[15] = zoomOut;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t5) {
    t11 = <FlexColumn className={t1} align="center" justify="between" gap="none">{t5}{t6}{t10}</FlexColumn>;
    $[17] = t10;
    $[18] = t5;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
};
function _temp(variant) {
  return css.raw({
    borderTopRadius: variant === "in" ? "full" : "none",
    borderBottomRadius: variant === "out" ? "full" : "none"
  });
}
function _temp2($) {
  return $.zoom_in;
}
function _temp3($_0) {
  return $_0.zoom_out;
}